const SSL = 'http://'

const MASTER = 'biso.yjz.top'

export default {
  master: MASTER,
  masterUrl: SSL + MASTER + '/',
  loginUrl: SSL + MASTER + '/login',
  demoImage: '/static/images/component_image.jpg'
}



// WEBPACK FOOTER //
// ./src/config/global.js